/**
 * Density strategy.
 */
function AdsNinjaDensityStrategyLeanTop(){

    AdsNinjaDensityStrategy.call(this);
}

AdsNinjaDensityStrategyLeanTop.prototype             = Object.create(AdsNinjaDensityStrategy.prototype);
AdsNinjaDensityStrategyLeanTop.prototype.constructor = AdsNinjaDensityStrategyLeanTop;

/**
 * @inheritdoc
 */
AdsNinjaDensityStrategyLeanTop.prototype.determineDistanceBetweenZones = function(
    numberOfAdsLeftToInject, 
    relativeSpaceLeftToInjectAdsIn, 
    minimumPixelDistanceBetweenZones
){
    
    if(numberOfAdsLeftToInject <= 0){

        return null;
    }

    // Lean Top.
    return window.adsNinja.utils.roundUpToTwoDecimalPoints(Math.max(Math.floor(((relativeSpaceLeftToInjectAdsIn - minimumPixelDistanceBetweenZones) / (numberOfAdsLeftToInject + 1))), minimumPixelDistanceBetweenZones));
};

window.AdsNinjaDensityStrategyLeanTop = AdsNinjaDensityStrategyLeanTop;